import Swiper from './lib/swiper-bundle.min';

export default () => {
  const mediaQueryList = window.matchMedia('(max-width: 767px)');

  const $swiperElement = document.getElementById('swiper');
  if (!$swiperElement) return;

  const $swiperWrapperElement = $swiperElement.firstElementChild;
  let swiper = null;

  const executeSlider = (mediaQueryList) => {
    if (mediaQueryList.matches) {
      $swiperElement.classList.remove('p-slider-container');
      $swiperWrapperElement.classList.remove('c-grid');
      swiper = new Swiper($swiperElement, {
        loop: true,
        speed: 800,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        autoplay: {
          delay: 5000,
        },
        spaceBetween: 15,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    } else {
      $swiperElement.classList.add('p-slider-container');
      $swiperWrapperElement.classList.add('c-grid');
      if (swiper === null) return;
      swiper.destroy();
    }
  };

  executeSlider(mediaQueryList);
  mediaQueryList.addEventListener('change', executeSlider);
}
